import { Form, DatePicker } from 'antd'
import dayjs from 'dayjs'

import './styles.css'


const FilterDateRange = ({ label, name, size }) => {
  return (
    <Form.Item name={name} label={label}>
      <DatePicker.RangePicker
        className="filterRange"
        format={"DD.MM.YYYY"}
        size={size}
        locale={{
          "lang": {
            "locale": "ru_RU",
            "placeholder": "Select date",
            "rangePlaceholder": ["Дата от", "Дата до"],
            "today": "Сегодня",
            "now": "Сейчас",
            "backToToday": "Назад к сегодня",
            "ok": "OK",
            "clear": "Очистить",
            "month": "Месяц",
            "year": "Год",
            "timeSelect": "Выбрать время",
            "dateSelect": "Выбрать дату",
            "monthSelect": "Выбрать месяц",
            "yearSelect": "Выбрать год",
            "decadeSelect": "Выбрать декаду",
            "yearFormat": "YYYY",
            "dateFormat": "DD.MM.YYYY",
            "dayFormat": "D",
            "dateTimeFormat": "DD.MM.YYYY HH:mm:ss",
            "monthFormat": "MMMM",
            "monthBeforeYear": true,
            "previousMonth": "Previous month (PageUp)",
            "nextMonth": "Next month (PageDown)",
            "previousYear": "Last year (Control + left)",
            "nextYear": "Next year (Control + right)",
            "previousDecade": "Last decade",
            "nextDecade": "Next decade",
            "previousCentury": "Last century",
            "nextCentury": "Next century"
          },
          "timePickerLocale": {
            "placeholder": "Выбрать время"
          },
          "dateFormat": "YYYY-MM-DD",
          "dateTimeFormat": "YYYY-MM-DD HH:mm:ss",
          "weekFormat": "YYYY-wo",
          "monthFormat": "YYYY-MM"
        }}
      />
    </Form.Item>
  );
}

FilterDateRange.getQueryParams = (values) => {
  if (values && values.length) {
    const start = values[0].format("DD.MM.YYYY");
    const end = values[1].format("DD.MM.YYYY");
    return `${start}--${end}`
  }
}

FilterDateRange.getValue = (values) => {
  if (values && values.length) {
    const [start, end] = values[0].split('--')
    return [dayjs(start, "DD.MM.YYYY"), dayjs(end, "DD.MM.YYYY")];
  }
}


export default FilterDateRange;
